import { useFormSubmit } from '@/features/settings/components/PrinterConfiguration/form'
import { OnFormSubmit } from '@/features/settings/components/PrinterConfiguration/form/types'
import Button from '@/features/ui/buttons/components/Button'
import CheckmarkIcon from '@/features/ui/icons/components/CheckmarkIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface SaveButtonProps {
    onSubmit: OnFormSubmit
}

const SaveButton: FC<SaveButtonProps> = ({ onSubmit }) => {
    const { t } = useTranslation()

    const [{ isValid, isSubmitting }, save] = useFormSubmit(onSubmit)

    return (
        <Button
            type="primary"
            FrontIcon={CheckmarkIcon}
            style={{ justifyContent: 'center' }}
            disabled={!isValid || isSubmitting}
            onPress={save}
        >
            {t('settings.printers.printerConfiguration.saveSettings').toUpperCase()}
        </Button>
    )
}

export default SaveButton
